import { rptmana, rptMana } from '@/api/index'

// export function GetRptModel (data: any) {
//   return rptmana.request({
//     method: 'post',
//     url: '/GetRptModel',
//     data,
//     iSFromData: true
//   })
// }
export function rpttypeQuery (data: any) {
  return rptMana.request({
    method: 'post',
    url: '/rpttypeQuery',
    data,
    iSFromData: true
  })
}
export function rptModelManaDelete (data: any) {
  return rptMana.request({
    method: 'post',
    url: '/rptModelManaDelete',
    data,
    iSFromData: true
  })
}
export function rptModelManaSetDefault (data: any) {
  return rptMana.request({
    method: 'post',
    url: '/rptModelManaSetDefault',
    data,
    iSFromData: true
  })
}
export function rptModelManaRemoveDefault (data: any) {
  return rptMana.request({
    method: 'post',
    url: '/rptModelManaRemoveDefault',
    data,
    iSFromData: true
  })
}
export function getModelByTypeID (data: any) {
  return rptMana.request({
    method: 'post',
    url: '/getModelByTypeID',
    data,
    iSFromData: true
  })
}
export function GetModelVersion (data: any) {
  return rptMana.request({
    method: 'post',
    url: '/GetModelVersion',
    data,
    iSFromData: true
  })
}
export function UseModelVersion (data: any) {
  return rptMana.request({
    method: 'post',
    url: '/UseModelVersion',
    data,
    iSFromData: true
  })
}
export function rptmodelSave (data: any) {
  return rptMana.request({
    method: 'post',
    url: '/rptmodelSave',
    data,
    iSFromData: true
  })
}
export function rptmodelSave_rl_new (data: any) {
  return rptMana.request({
    method: 'post',
    url: '/rptmodelSave_rl_new',
    data,
    iSFromData: true
  })
}
export function rptmodelSaveLog (data: any) {
  return rptMana.request({
    method: 'post',
    url: '/rptmodelSaveLog',
    data,
    iSFromData: true
  })
}
export function CopyModelVersion (data: any) {
  return rptMana.request({
    method: 'post',
    url: '/CopyModelVersion',
    data,
    iSFromData: true
  })
}
